import { render, staticRenderFns } from "./ControlAuto.vue?vue&type=template&id=47612124&scoped=true"
import script from "./ControlAuto.vue?vue&type=script&lang=js"
export * from "./ControlAuto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47612124",
  null
  
)

export default component.exports